export const GLASS_PARAMS = {
	scaleFactor: 10,
	glass: {
		topRadius: 4.2,
		bottomRadius: 2.9,
		height: 12.3,
		// 上端と下端の色（16進数）
		topColor: 0xdddddd,
		bottomColor: 0xdddddd,
		radialSegments: 32,
		heightSegments: 1,
		openEnded: false,
		color: 0xdddddd,
		shininess: 30,
		yOffset: 0,
	},
	shearMatrix: [
		1, 0, 0, 0,
		0, 1, 0, 0,
		0, 0, 1, 0,
		0, 0, 0, 1,
	],
	light: {
		ambient: { color: 0x404040, intensity: 1.5 },
		spot: { color: 0xffffff, intensity: 2, position: [0, 0, 0] },
	},
};
